import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {ObservableBackendService} from "./observableBackend.service";
import {User} from "../domain/user";
import {URLSearchParams} from "@angular/http";
import {Page} from "../domain/page";

@Injectable()
export class OperatorsService {

    constructor(private backendService:ObservableBackendService) {
    }

    public findUsers(filter:string, page:number, itemsPerPage:number):Observable<Page> {
        let params = new URLSearchParams();
        if (filter) {
            params.set('searchParam', filter);
        }

        params.set('length', String(itemsPerPage));
        params.set('pageNumber', String(page));
        return this.backendService.get("users", params);
    }

    public getUser(userId:string):Observable<User> {
        return this.backendService.get("user/" + userId, null);
    }

    public getUserByUsername(username:string):Observable<User> {
        return this.backendService.get("user/validate/" + username, null);
    }

    public getNewUser():Observable<User> {
        return this.backendService.get("user/new", null);
    }

    public save(user:User):Observable<User> {
        if (user.id != null) {
            return this.backendService.post("user", user, null);
        } else {
            return this.backendService.put("user", user, null);
        }
    }

    public delete(userId:string):Observable<User> {
        return this.backendService.delete("user/" + userId, null, null);
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/service/operators.service.ts
 **/